import { Platform } from './entities';

export const comparePlatform = (p1: Platform, p2: Platform) => {
  return p1.platform_name === p2.platform_name || p1.platform_name === null || p2.platform_name === null
    ? 0
    : p1.platform_name > p2.platform_name
      ? 1
      : -1;
};
